/* import __COLOCATED_TEMPLATE__ from './teammate-app-boot-error.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
import Component from '@glimmer/component';
import type IntlService from 'ember-intl/services/intl';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { categorizeErrorMessage, type ErrorCategory } from 'embercom/lib/island-error-category';

const TRANSLATION_KEYS: Record<ErrorCategory, { heading: string; description: string }> = {
  'script-load': {
    heading: 'components.teammate-app-boot-error.heading.script-load',
    description: 'components.teammate-app-boot-error.description.script-load',
  },
  timeout: {
    heading: 'components.teammate-app-boot-error.heading.timeout',
    description: 'components.teammate-app-boot-error.description.timeout',
  },
  'init-failure': {
    heading: 'components.teammate-app-boot-error.heading.init-failure',
    description: 'components.teammate-app-boot-error.description.init-failure',
  },
  unknown: {
    heading: 'components.teammate-app-boot-error.heading.unknown',
    description: 'components.teammate-app-boot-error.description.unknown',
  },
};

const STEP_KEYS: Record<ErrorCategory, string[]> = {
  'script-load': [
    'components.teammate-app-boot-error.steps.script-load.start-server',
    'components.teammate-app-boot-error.steps.script-load.check-terminal',
    'components.teammate-app-boot-error.steps.script-load.run-update',
  ],
  timeout: [
    'components.teammate-app-boot-error.steps.timeout.reload-page',
    'components.teammate-app-boot-error.steps.timeout.check-terminal',
    'components.teammate-app-boot-error.steps.timeout.restart-server',
    'components.teammate-app-boot-error.steps.timeout.run-update',
  ],
  'init-failure': [
    'components.teammate-app-boot-error.steps.init-failure.check-console',
    'components.teammate-app-boot-error.steps.init-failure.check-terminal',
    'components.teammate-app-boot-error.steps.init-failure.run-update',
    'components.teammate-app-boot-error.steps.init-failure.restart-server',
  ],
  unknown: [
    'components.teammate-app-boot-error.steps.unknown.check-console',
    'components.teammate-app-boot-error.steps.unknown.check-terminal',
    'components.teammate-app-boot-error.steps.unknown.run-update',
    'components.teammate-app-boot-error.steps.unknown.restart-server',
  ],
};

interface Signature {
  Args: {
    errorMessage?: string;
    errorDetail?: string;
  };
}

export default class TeammateAppBootError extends Component<Signature> {
  @service declare intl: IntlService;

  get errorCategory(): ErrorCategory {
    return categorizeErrorMessage(this.args.errorMessage ?? '');
  }

  get heading(): string {
    return this.intl.t(TRANSLATION_KEYS[this.errorCategory].heading);
  }

  get description(): string {
    return this.intl.t(TRANSLATION_KEYS[this.errorCategory].description);
  }

  get stepKeys(): string[] {
    return STEP_KEYS[this.errorCategory];
  }

  get showReloadButton(): boolean {
    return this.errorCategory === 'timeout';
  }

  @action
  reload() {
    window.location.reload();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    TeammateAppBootError: typeof TeammateAppBootError;
    'teammate-app-boot-error': typeof TeammateAppBootError;
  }
}
